import React from "react";
import { Alert as MUIAlert } from "@mui/material";
import styled from "styled-components";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import theme from "../../../Portal/web/Content/js/lib/themes/theme";

const StyledMUIAlert = styled(MUIAlert)`
  border-radius: ${({ size }) =>
    size === "large" ? "16px !important" : "8px !important"};
  box-shadow:
    0px 3px 5px -1px rgba(60, 71, 95, 0.2),
    0px 5px 8px rgba(60, 71, 95, 0.14),
    0px 1px 14px rgba(60, 71, 95, 0.12) !important;
  ${({ variant, severity }) =>
    variant === "standard"
      ? `background-color:${theme.palette[severity].light} !important;`
      : ""}

  ${({ variant, severity }) =>
    variant === "standard"
      ? `color:${theme.palette[severity].main} !important;`
      : ""}

  .MuiAlert-message {
    display: flex;
    align-items: center;
    font-size: ${({ size }) => (size === "large" ? "16px" : "14px")};
  }
`;

export const Alert = React.forwardRef(
  (
    {
      severity = "success",
      message,
      variant = "standard",
      onClose,
      size = "large",
    },
    ref,
  ) => {
    const icons = {
      info: <InfoIcon fontSize={size} />,
      warning: <WarningIcon fontSize={size} />,
      error: <ErrorIcon fontSize={size} />,
      success: <CheckCircleIcon fontSize={size} />,
    };

    return (
      <StyledMUIAlert
        ref={ref}
        severity={severity}
        variant={variant}
        {...(size === "large" && { icon: icons[severity] })}
        sx={{ boxShadow: "lg" }}
        onClose={onClose}
        size={size}
        theme={theme}
      >
        {message}
      </StyledMUIAlert>
    );
  },
);

Alert.displayName = "Alert";
